<docs>
  # UiKit - Button - nav
  > *generic way to create any nav cta*
</docs>

<script lang="ts">
import ArrowSVG from "assets/svg/arrow.svg?raw";
import PointsSVG from "assets/svg/points.svg?raw";
import { store as responsiveStore } from "components/Responsive/store";
import { computed, defineComponent, PropType } from 'vue';
import UiButtonSimple from './index.vue';

const UiThemedButtonNav = defineComponent({
  name: "UiButtonThemednav",
  components: { UiButtonSimple },
  extends: UiButtonSimple,
  props: {
    theme: {
      type: String as PropType<ButtonTheme>,
      default: 'nav'
    },
    direction: {
      type: String as PropType<ButtonDirection>,
      default: 'left'
    },
    icon: {
      type: String,
      default: PointsSVG
    },
    expand: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      ArrowSVG,
      hoverDistance: computed(() => `${8 * responsiveStore.desktop}px`),
      hoverDistanceNeg: computed(() => `${-8 * responsiveStore.desktop}px`),
    }
  }
});
export default UiThemedButtonNav
</script>

<template>
  <ui-button-simple class="UiButtonThemed"
                    :data-theme="theme"
                    :data-variant="variant"
                    :data-dark="dark"
                    :data-selected="selected"
                    :data-expand="expand"
                    :data-highlight="true"
                    v-bind="$props"
  >
    <slot>
      <span v-if="$props.label"
            ref="label"
            class="label"
            :data-label="$props.label"
      >{{ $props.label }}</span>
      <i v-if="expand"
         class="icon-expand"
         v-html="ArrowSVG"
      />
    </slot>
  </ui-button-simple>
</template>

<style lang="stylus" scoped>
  // Mixins for hover - small refactoring
  navHover()
    &[data-expand="false"]
      opacity 1
      .label
        transform translateX(v-bind(hoverDistance))
      :deep()
        .inner
          .icon
            transform scaleX(1)
    &[data-expand="true"]
      opacity 1
      :deep()
        .inner
          .icon
            transform scaleX(1) translateX(v-bind(hoverDistanceNeg))

  [data-theme="nav"]
    position relative
    user-select none
    display inline-block
    f-style(button)
    trans(color)
    trans(opacity)
    
    &:not(.router-link-exact-active)&:not(&[data-selected="true"]), &[data-selected="false"]
      opacity .6

    &[data-dark="true"]
      addVariantProps($dark:true)
    &[data-dark="false"]
      addVariantProps($dark:false)

    :deep()
      .inner
        width 100%
        f(row, $align:center)
        .icon
          position absolute
          rp(width, 8px)
          rp(height, 8px)
          trans(transform)
          [data-selected="false"]&
            transform scale(0)
          [data-selected="true"][data-expand="true"]&
            transform translateX(v-bind(hoverDistanceNeg))
        .icon-expand
          position relative
          rp(width, 7px)
          rp(height, 7px)
          top 2px
          margin-left 8px
          trans(transform)
          trans(top)
          transform rotate(90deg)
          [data-selected="true"]&
            transform rotate(-90deg)
            top 1px
        svg
          display block

    .label
      display block
      [data-expand="false"]&
        trans(transform)

    +hover()
      navHover()
    $:focus, &[data-selected="true"]
      navHover()
</style>
